// extracted by mini-css-extract-plugin
export default {"root":"root--EVWBg","extrasBtnText":"extrasBtnText--u8AiX","table":"table--aXSkY","editIconBtn":"editIconBtn--QxXfX","addIcon":"addIcon--kbS3Y","designV2":"designV2--w41LP"};